import { defineComponent as b, useAttrs as V, useSlots as N, inject as B, computed as K, createElementBlock as S, openBlock as s, Fragment as x, createBlock as v, createCommentVNode as k, createVNode as M, unref as i, h as m } from "vue";
import { Constants as R, ContentRendererService as d } from "@magnolia/frontend-helpers-base";
import p from "./vue-editor4.js";
import $ from "./vue-editor5.js";
const W = /* @__PURE__ */ b({
  name: "EditableArea",
  inheritAttrs: !1,
  __name: "EditableArea",
  props: {
    content: { default: () => {
    } },
    elementType: { default: "div" },
    customView: { default: () => {
    } },
    areaConfig: { default: () => ({
      fallthrough: !0,
      passAttrsToChildComponents: !1,
      unwrapAttrsToChildComponents: !1
    }) }
  },
  setup(t) {
    const {
      fallthrough: f,
      passAttrsToChildComponents: h,
      unwrapAttrsToChildComponents: C
    } = t.areaConfig, r = V(), T = N(), A = t.elementType !== "", a = B(
      "templateAnnotations"
    ), g = () => {
      var e, l, n;
      return t.content && a && (l = a.value) != null && l[(e = t.content) == null ? void 0 : e["@path"]] ? a == null ? void 0 : a.value[(n = t.content) == null ? void 0 : n["@path"]] : "";
    }, w = () => {
      var y;
      const e = T.default || void 0, n = {
        attrs: h && !C ? r : null,
        ...h && C ? r : {}
      };
      if (e)
        return e({
          ...n,
          content: t.content,
          key: d.buildKey(t.content)
        });
      if (t.customView) {
        const o = !A && f ? r : {};
        return m(t.customView, {
          ...o,
          ...n,
          content: t.content,
          key: d.buildKey(t.content)
        });
      }
      return ((y = t.content) == null ? void 0 : y["@nodes"]).map(
        (o) => {
          var c;
          return (c = t.content) == null ? void 0 : c[o];
        }
      ).map(
        (o, c) => m($, {
          ...n,
          content: o,
          key: d.buildKey(o),
          index: c
        })
      );
    }, E = () => {
      if (!t.content)
        return null;
      const e = w();
      return A ? m(t.elementType, f ? r : {}, e) : e;
    }, u = K(() => g());
    return (e, l) => (s(), S(x, null, [
      u.value ? (s(), v(i(p), {
        key: 0,
        annotation: u.value,
        "should-refresh": !0
      }, null, 8, ["annotation"])) : k("", !0),
      M(E),
      u.value ? (s(), v(i(p), {
        key: 1,
        annotation: i(R).END_AREA_COMMENT
      }, null, 8, ["annotation"])) : k("", !0)
    ], 64));
  }
});
export {
  W as default
};
//# sourceMappingURL=vue-editor3.js.map
